const features = [
  {
    icon: 'ri-live-line',
    title: '高清直播',
    description: '1080P高清画质直播，流畅不卡顿，犹如亲临现场感受演艺魅力',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端兼容',
    description: '完美适配安卓与iOS设备，手机平板均可畅享，随时随地观看精彩',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '官方正版应用，多重安全防护，保障您的账号和隐私信息安全',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '会员特权',
    description: 'VIP会员畅享去广告、独播内容、离线下载等多项专属权益',
  },
  {
    icon: 'ri-user-heart-line',
    title: '互动体验',
    description: '弹幕互动、礼物打赏、实时投票，与演艺达人零距离交流互动',
  },
  {
    icon: 'ri-notification-3-line',
    title: '智能推荐',
    description: '基于观看偏好的个性化算法，为您精准推荐感兴趣的演艺内容',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            为什么选择<strong>东升大舞台</strong>？
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            六大核心优势，为您打造极致的演艺娱乐体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-200 transition-colors group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h4 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}